
export default {
  mounted() {
    let slug = this.$route.params.redirect
    switch(slug){
      case 'moto-max':
        this.$router.push('/products/assets-and-property/motoone')
        break        
      case 'condominium-must-haves':
        this.$router.push('/news')
        break
      case 'family-relief':
        this.$router.push('/products/personal-and-family/vital-cover')
        break
      case 'insurance-claims':
        this.$router.push('/news/malayan-enables-online-notification-insurance-claims')
        break
      case 'car-sales-double-digit-growth':
        this.$router.push('/products/assets-and-property/automaster')
        break
      case 'travellite':
        this.$router.push('/products/lifestyle/travel-lite')
        break
      default:
        this.$router.push('/products')
        break
    }
  }
  
};  
